import { InfoWorkType, WorkType } from '@kanda-libs/ks-frontend-services';
import { URLS } from 'config';
import { useCallback } from 'react';
import { generatePath, useHistory } from 'react-router-dom';
import { scrollToTop } from 'utils';
import { useEnquiryContext } from '../context';

export interface EnquiryLandingHook {
  onQuoteClick: () => void;
  onEnquiryClick: () => void;
  tradingName: string;
  infoWorkTypes: InfoWorkType[] | undefined;
  workType: WorkType | undefined;
  isLoading: boolean;
}

export default function useEnquiryLanding(): EnquiryLandingHook {
  const { id, tradingName, isLoading, infoWorkTypes, workType } =
    useEnquiryContext();
  const { push } = useHistory();

  const onEnquiryClick = useCallback(() => {
    if (!id) return;
    scrollToTop();
    push(generatePath(URLS.enquiryWelcome, { id }));
  }, [id, push]);

  const onQuoteClick = useCallback(() => {
    if (!id) return;
    scrollToTop();
    push(generatePath(URLS.enquiryQuoteWelcome, { id }));
  }, [id, push]);

  return {
    onEnquiryClick,
    onQuoteClick,
    tradingName,
    infoWorkTypes,
    workType,
    isLoading,
  };
}
